// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__PRLz-","message":"Messages_message__-3QCS"};